import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ContextLine } from './context-line';
export const LocaleTextField = (props) => {
    const { label, content } = props;
    return (_jsx(ContextLine, { label: label, lineColor: "components.language-picker.input.line", color: "components.language-picker.input.text", children: content }));
};
